<template>
  <div class="form-group row memory-quote">
    <label :for="`title-${number}`" class="memory-quote__quote-label col-md-2">Quote {{ number + 1 }}</label>
    <button class="memory-quote__close-btn col-md-10" @click="deleteQuote">
      <i class="fa fa-times" aria-hidden="true" />
    </button>

    <label :for="`title-${number}`" class="memory-quote__sub-label col-md-2">Text</label>
    <div class="col-md-10 mb-1">
      <textarea
        :id="`title-${number}`"
        v-model="quote.text"
        rows="3"
        placeholder="Enter quote text"
        class="form-control"
      />
    </div>

    <label :for="`title-${number}`" class="memory-quote__sub-label col-md-2">More Info</label>
    <div class="col-md-10 mb-1">
      <textarea
        :id="`title-${number}`"
        v-model="quote.more_info"
        rows="2"
        placeholder="Enter more info"
        class="form-control"
      />
    </div>

    <label :for="`title-${number}`" class="memory-quote__sub-label col-md-2">Link</label>
    <div class="col-md-10 mb-1">
      <input
        type="text"
        :id="`title-${number}`"
        v-model="quote.link"
        placeholder="Enter link"
        class="form-control"
      />
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'MemoryQuote',
  props: {
    number: {
      type: Number,
      required: true,
    },
    quote: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteQuote() {
      this.$emit('deleteQuote', this.number);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MemoryQuote.vue?eb55f1a4